/* Publish by EComposer at 2026-10-05 20:13:24*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mgq0evc4vw"]=  window.__ectimmers["ecom-mgq0evc4vw"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-mgq0evc4vw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mgq0evc4vw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f8s7r48hud').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f8s7r48hud', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tfmv35ehjm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tfmv35ehjm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-si3a2ekjrmo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-si3a2ekjrmo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b3u0cljs1sb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b3u0cljs1sb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7181xl5tctq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7181xl5tctq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9d19sv6f9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9d19sv6f9r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-imdq7o1y43q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-imdq7o1y43q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nrczeb840cf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nrczeb840cf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6sxagtze87k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6sxagtze87k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qmec4aohx4f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmec4aohx4f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p66tnrxxp9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p66tnrxxp9r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a7u87vou0pv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a7u87vou0pv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-89crtko007k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-89crtko007k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vcq1eq00kkg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vcq1eq00kkg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wzilll06zq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wzilll06zq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m5281wmkz9o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m5281wmkz9o', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-xcgx3zb1kqb"]=  window.__ectimmers["ecom-xcgx3zb1kqb"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-xcgx3zb1kqb"]["5fcrdughg"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-xcgx3zb1kqb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xcgx3zb1kqb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cx25zdp3y7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cx25zdp3y7c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n6uvvh3kohl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n6uvvh3kohl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hhk47lmyfst').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hhk47lmyfst', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rehzcyn766g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rehzcyn766g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gxsfswxrynn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gxsfswxrynn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d2f1sgy0dpv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d2f1sgy0dpv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t1fum5qxo2c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t1fum5qxo2c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3c3rywvlyzj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3c3rywvlyzj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ymo4faay479').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ymo4faay479', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qm4afy39snm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qm4afy39snm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6yrtngvij3q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6yrtngvij3q', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7nxgmhguh9"]=  window.__ectimmers["ecom-7nxgmhguh9"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-7nxgmhguh9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7nxgmhguh9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-la8wcj82ow8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-la8wcj82ow8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r0ts5x1qdsm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r0ts5x1qdsm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w3dmt8kkaw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w3dmt8kkaw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b67wpt8pwj7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b67wpt8pwj7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w1ivnnvs9z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w1ivnnvs9z', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l0zskcchpo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l0zskcchpo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ulczrjx1rn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ulczrjx1rn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ewhbcwchgtp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ewhbcwchgtp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vatpome23v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vatpome23v', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-28jh2u8txtk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-28jh2u8txtk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-up6ipwsv2fc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-up6ipwsv2fc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-if8ymhy9kd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-if8ymhy9kd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hho458dn90d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hho458dn90d', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mxbe1dujej').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mxbe1dujej', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y77x83nuso').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y77x83nuso', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a2q7x9h1lnm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a2q7x9h1lnm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6wbvskm2rax').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6wbvskm2rax', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-16x0uxyaf7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-16x0uxyaf7c', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nczmp4rb74').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nczmp4rb74', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}